/**
 * Fires exactly one GA4 `page_view` per user-perceived navigation: once
 * when the app mounts on the client, and once on every subsequent route
 * path change.
 */
export function usePageViewTracking(): void {
  if (!import.meta.client) return

  const gtm = useGtm()
  if (!gtm) return

  const route = useRoute()

  watch(
    () => route.path,
    () => {
      gtm.trackEvent({
        event: 'page_view',
        page_section: usePageSection(),
        page_path: route.fullPath,
        page_title: document.title,
      })
    },
    { immediate: true, flush: 'post' },
  )
}
